import { create } from "zustand";

interface BodyRemovalDetailsState {
  deceasedLocation: {
    houseNumber: string;
    streetName: string;
    suburb: string;
    city: string;
    province: string;
    postalCode: string;
    locationType: string;
    notes: string;
  };
  setBodyRemovalDetails: (
    data: Partial<BodyRemovalDetailsState["deceasedLocation"]>,
  ) => void;
  resetBodyRemovalDetails: () => void;
}

export const useBodyRemovalDetailsStore = create<BodyRemovalDetailsState>(
  (set) => ({
    deceasedLocation: {
      houseNumber: "",
      streetName: "",
      suburb: "",
      city: "",
      province: "",
      postalCode: "",
      locationType: "",
      notes: "",
    },
    setBodyRemovalDetails: (data) =>
      set((state) => ({
        deceasedLocation: {
          ...state.deceasedLocation,
          ...data,
        },
      })),
    resetBodyRemovalDetails: () =>
      set(() => ({
        deceasedLocation: {
          houseNumber: "",
          streetName: "",
          suburb: "",
          city: "",
          province: "",
          postalCode: "",
          locationType: "",
          notes: "",
        },
      })),
  }),
);
